import { DatatableCell, Skeleton } from '@monksflow/monks-ui';
import { TableSkeletonActionsCell, TableSkeletonRow } from '@/shared/ui/data-table';

interface AudiencesTableV2SkeletonRowProps {
  showActions: boolean;
}

/**
 * Mirrors the SHAPE of a real audience row — avatar + name, then the narrower
 * data columns — so the skeleton reads as a table rather than a block of grey
 * bars. Column order tracks {@link AudiencesTableV2}'s header.
 */
export const AudiencesTableV2SkeletonRow = ({ showActions }: AudiencesTableV2SkeletonRowProps) => (
  <TableSkeletonRow testId="audiences-table-skeleton-row">
    <DatatableCell>
      <div className="flex items-center gap-2">
        <Skeleton className="size-6 rounded-full" />
        <Skeleton className="h-4 w-40" />
      </div>
    </DatatableCell>

    <DatatableCell>
      <div className="flex gap-xs">
        <Skeleton className="h-5 w-20 rounded-full" />
        <Skeleton className="h-5 w-20 rounded-full" />
      </div>
    </DatatableCell>

    <DatatableCell>
      <Skeleton className="h-4 w-24" />
    </DatatableCell>

    <DatatableCell>
      <Skeleton className="h-5 w-16 rounded-full" />
    </DatatableCell>

    <DatatableCell>
      <Skeleton className="h-4 w-20" />
    </DatatableCell>

    {showActions && <TableSkeletonActionsCell />}
  </TableSkeletonRow>
);

AudiencesTableV2SkeletonRow.displayName = 'AudiencesTableV2SkeletonRow';
